import { render, staticRenderFns } from "./NotesLabel.vue?vue&type=template&id=0696ac5c&"
import script from "./NotesLabel.vue?vue&type=script&lang=js&"
export * from "./NotesLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports